// extracted by mini-css-extract-plugin
export default {"title":"WFgN2P mz-caption","icon":"Y6ea6Q mz-caption"};